module.exports = __webpack_public_path__ + "static/media/Achilles.a78e071c.jpg";